import { Reducer } from 'react'
import { AnyAction, combineReducers } from 'redux'
import { busyReducer, BusyState } from './busy'
import { configReducer, ConfigState } from './config'
import { profileReducer, ProfileState } from './profile'

export interface ApplicationState {
	busy: BusyState
	profile: ProfileState
	config: ConfigState
}

export const createRootReducer = (): Reducer<ApplicationState, AnyAction> =>
	combineReducers<ApplicationState>({
		busy: busyReducer,
		profile: profileReducer,
		config: configReducer
	})
